export const CURRENT = 'CURRENT';
export const DRAFT = 'DRAFT';
export const LEGACY = 'LEGACY';
export const MULTIPLE = 'MULTIPLE';